import React, { useState, useEffect } from "react";
import Button from "@/component/Button";
import DocxViewer from "./DocxViewer.tsx";
import TxtViewer from "./TxtViewer.tsx";
import { UploadedFile } from "../../index";
import LoadingIcon from "@/assets/common/ic_loading_blue.png";
import "./index.css";
import { message } from "antd";

interface FilePreviewProps {
  file: UploadedFile;
}

const FilePreview: React.FC<FilePreviewProps> = ({ file }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 重置状态
    setIsLoading(true);
    setError(null);

    // 模拟加载过程
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [file]);

  useEffect(() => {
    if (error) {
      message.warning('无法读取文件内容，请重新选择文件上传');
    }
  }, [error]);

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const renderPreview = () => {
    if (isLoading) {
      return (
        <div className="flex flex-col items-center mt-38">
          <img src={LoadingIcon} className="size-6 animate-spin" />
          <p className="text-#626773CC text-size-3.5 mt-4">正在加载预览...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="preview-error">
          <p>预览失败: {error}</p>
          <Button onClick={() => setError(null)}>重试</Button>
        </div>
      );
    }

    switch (file.type) {
      case "docx":
        return <DocxViewer file={file} onError={setError} />;
      case "doc":
        return (
          <div className="preview-unsupported">
            <p>DOC格式暂不支持预览，请转换为DOCX格式</p>
            <p>文件名: {file.name}</p>
            <p>文件大小: {formatFileSize(file.size)}</p>
          </div>
        );
      case "txt":
        return <TxtViewer file={file} onError={setError} />;
      default:
        return (
          <div className="preview-unsupported">
            <p>不支持的文件类型</p>
          </div>
        );
    }
  };

  return <div className="py-2 px-6 text-#191d26b3 text-size-3.5" style={{ lineHeight: '2' }}>{renderPreview()}</div>;
};

export default FilePreview;
